'use client';

import { useState } from 'react';
import { SearchRangeWebIcon } from '../Icons/Icons';
import SourceSettingsDrawer from './SourceSettingsDrawer';

const SeacrhRange = ({
  focusMode,
  setFocusMode,
}: {
  focusMode?: string[];
  setFocusMode?: (mode: string[]) => void;
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleIconClick = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  return (
    <>
      <div className="flex flex-row items-center space-x-1">
        <button
          type="button"
          onClick={handleIconClick}
          className="rounded-lg p-1 hover:bg-gray-100 dark:hover:bg-[#2B2D30] transition-all"
        >
          <SearchRangeWebIcon />
        </button>
      </div>

      <SourceSettingsDrawer open={drawerOpen} onClose={handleDrawerClose} />
    </>
  );
};

export default SeacrhRange;
